"use client";

import { useRef, useState, useEffect } from "react";
import Link from "next/link";

export interface AboutSectionProps {
  description: string | null;
  descExpanded: boolean;
  setDescExpanded: (expanded: boolean) => void;
  tags: string[];
}

export function AboutSection({
  description,
  descExpanded,
  setDescExpanded,
  tags,
}: AboutSectionProps) {
  const descRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = descRef.current;
    if (el) {
      setIsTruncated(el.scrollHeight > el.clientHeight);
    }
  }, [description]);

  return (
    <div className="bg-[#0c0c18] border border-white/[0.08] rounded-[20px] p-7 transition-colors hover:border-white/[0.12]">
      <div className="flex items-center justify-between mb-5">
        <span className="text-[11px] uppercase tracking-[0.1em] font-semibold text-white/50">Description</span>
      </div>
      <div ref={descRef} className={`text-white/60 text-sm leading-[1.8] whitespace-pre-line ${descExpanded ? "" : "line-clamp-5"}`}>
        {description || "No description provided yet."}
      </div>
      {description && isTruncated ? (
        <button type="button" onClick={() => setDescExpanded(!descExpanded)} className="text-[#4A8BFF] text-[13px] font-medium mt-2 hover:underline">
          {descExpanded ? "Show less" : "Read more"}
        </button>
      ) : null}
      {tags.length > 0 ? (
        <div className="flex flex-wrap gap-2 mt-5">
          {tags.map((tag) => (
            <Link
              key={tag}
              href={`/?tag=${encodeURIComponent(tag)}`}
              className="px-3.5 py-1.5 rounded-full bg-white/[0.04] border border-white/[0.08] text-white/60 text-xs font-medium hover:text-white hover:border-white/[0.12] transition"
            >
              #{tag}
            </Link>
          ))}
        </div>
      ) : null}
    </div>
  );
}
